import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

var MonitorApi = require('monitor-api');

export function InputTabelle({ zvs, instance, reloadData }) {
    const { uniqueYear } = useParams();
    const [newNumbers, setNewNumbers] = useState([]);

    useEffect(() => {
        // console.log('>>neu');
        zvs.forEach(zv => {
            let newObject = new MonitorApi.EinwohnerCreate();
            newObject.idZv = zv.id;
            newObject.jahr = uniqueYear;
            setNewNumbers(previous => [...previous, newObject]);
        });
    }, [zvs, uniqueYear]);

    const getInput = event => {
        event.preventDefault();
        // console.log(event.target.id, event.target.value);
        // console.log(newNumbers);
        if (event.target.value >= 0) {
            const changing = newNumbers.filter(obj => obj.idZv === parseInt(event.target.id))
            changing[0].einwohner = event.target.value;
            setNewNumbers(old => [...old.filter(obj => obj.idZv !== parseInt(event.target.id)), ...changing]);
            
        }
        // console.log('>>changing', changing);

    }

    const existRemains = () => {
        if (newNumbers.filter(obj => obj.einwohner === undefined || obj.einwohner === "").length > 0) {
            return true
        }
        return false
    }

    // const cancel = event => {
    //     event.preventDefault();
    //     setNewNumbers([]);
    // } 

    const saveNews = event => {
        event.preventDefault();
        console.log('>>', newNumbers)
        instance.addEinwohnerForAllZvs(newNumbers, (error, data) => {
            if (error) {
                console.log(error);
            } else {
                console.log(data);
                reloadData(uniqueYear);
            }
        })
    }

    return (
        <div>
            <h4>Neue Einträge für {uniqueYear} erstellen:</h4>
            {/* <aside>{JSON.stringify(newNumbers)}</aside> */}
            <form className="einwohner-input">
                <ul type="none">
                    {zvs.map(zv => <li key={zv.id}>
                        <label>{zv.name}:   </label>
                        <input id={zv.id} type="number" placeholder='Einwohner' onInput={getInput}/>
                    </li>
                    )}
                </ul>
            </form>
            {/* <button onClick={cancel}>Abbrechen</button> */}
            <button disabled={existRemains()} onClick={saveNews}>Speichern</button>
            {/* <aside>{newNumbers.map(obj => <div key={obj.id_zv}><label key={obj.id_zv}>{JSON.stringify(obj)}</label><br></br></div>)}</aside> */}
        </div>
    );
}
